import { Link } from "react-router-dom";

const quickLinks = [["/", "Home"], ["/about", "About Us"], ["/services", "Services"], ["/projects", "Projects"], ["/contact", "Contact"]];
const serviceLinks = [
  ["/services#transportation", "Transportation"],
  ["/services#cargo", "Cargo Solutions"],
  ["/services#spare-parts", "Aircraft Spare Parts"],
  ["/services#cross-border", "Cross-Border Transactions"],
  ["/services#imports", "Import Services"],
  ["/services#manufacturing", "Manufacturing"],
];

export default function Footer() {
  return (
    <footer className="footer">
      <div className="svc-bg-image" style={{ backgroundImage: 'url("/assets/hero-bg-4.webp")' }} />
      <div className="svc-bg-overlay svc-bg-overlay--navy" />
      <div className="footer-container">
        <div className="footer-col">
          <h2 className="footer-logo">FinFlux</h2>
          <p>A trusted aviation partner delivering innovative aviation solutions, operational excellence, and strategic support across global markets, connecting businesses through safe, efficient, and reliable services.</p>
        </div>
        <div className="footer-col">
          <h3>Quick Links</h3>
          <ul>{quickLinks.map(([to, label]) => <li key={to}><Link to={to}>{label}</Link></li>)}</ul>
        </div>
        <div className="footer-col">
          <h3>Our Services</h3>
          <ul>{serviceLinks.map(([to, label]) => <li key={to}><Link to={to}>{label}</Link></li>)}</ul>
        </div>
      </div>
      <div className="footer-bottom"><p>© 2026 FinFlux. All Rights Reserved.</p></div>
    </footer>
  );
}
